import { type Component } from 'vue';

const iconModules = import.meta.glob('./*.vue', { eager: true }) as unknown as Record<
  string,
  { default: Component }
>;

/**
 * Resolve an icon component by name.
 *
 * All icons in this directory are statically bundled via import.meta.glob
 * with eager loading. Call this function wherever an icon name is only
 * known at runtime (e.g. received as a string prop).
 *
 * @example
 * import { getIconComponent } from '@link11/ui-component-library';
 * const icon = computed(() => getIconComponent(props.icon));
 */
export function getIconComponent(name: string): Component | '' {
  const module = iconModules[`./${name}.vue`];
  return module ? module.default : '';
}
